import { render } from "./ReplaceItem.vue?vue&type=template&id=6226eef1"
import script from "./ReplaceItem.vue?vue&type=script&lang=js"
export * from "./ReplaceItem.vue?vue&type=script&lang=js"
script.render = render

export default script